import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLocale } from '../context/LocaleContext';
import { useNavigate } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';

export default function GuestSeductionModal({ isOpen, onClose }) {
  const { t } = useLocale();
  const navigate = useNavigate();

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[70] flex items-center justify-center px-4 sm:px-0">
          <motion.div 
            initial={{ opacity: 0 }} 
            animate={{ opacity: 1 }} 
            exit={{ opacity: 0 }} 
            className="absolute inset-0 bg-gray-900/60 backdrop-blur-sm" 
            onClick={onClose} 
          />
          <motion.div 
            initial={{ scale: 0.9, opacity: 0, y: 20 }} 
            animate={{ scale: 1, opacity: 1, y: 0 }} 
            exit={{ scale: 0.9, opacity: 0, y: 20 }} 
            className="bg-white dark:bg-slate-800 w-full max-w-[360px] rounded-[2.5rem] shadow-2xl relative z-10 flex flex-col overflow-hidden border-4 border-white dark:border-slate-700"
          >
            {/* 慶祝風頂部 */}
            <div className="bg-gradient-to-br from-pink-100 to-rose-200 dark:from-pink-900/40 dark:to-rose-900/40 p-8 text-center relative overflow-hidden">
              <div className="absolute -top-10 -right-10 w-32 h-32 bg-white/30 rounded-full blur-2xl pointer-events-none"></div>
              <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-white/30 rounded-full blur-2xl pointer-events-none"></div>
              
              <div className="text-6xl mb-4 relative z-10 animate-bounce-mini drop-shadow-sm">🎉</div>
              <h3 className="text-2xl font-black text-rose-700 dark:text-pink-300 relative z-10 break-words leading-tight">
                {t('seduction.title')}
              </h3>
            </div>

            {/* 內文引導 */}
            <div className="p-6 text-center">
              <p className="text-gray-800 dark:text-gray-200 font-bold text-lg mb-3">
                {t('seduction.message1')}
              </p>
              <div className="bg-gray-50 dark:bg-slate-900 p-4 rounded-2xl text-gray-500 dark:text-gray-400 text-sm font-medium leading-relaxed border border-gray-100 dark:border-slate-700">
                {t('seduction.message2')}
                <br/><br/>
                {t('seduction.message3')}
              </div>
            </div>

            {/* 按鈕操作區 */}
            <div className="px-6 pb-6 space-y-3">
              <button 
                onClick={() => {
                  onClose();
                  navigate('/login');
                }}
                className="w-full py-4 bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 text-white rounded-2xl font-bold shadow-lg shadow-pink-200 dark:shadow-none active:scale-95 transition-all text-lg flex items-center justify-center gap-2"
              >
                <SafeIcon name="Cloud" className="w-5 h-5" />
                {t('seduction.registerBtn')}
              </button>
              <button 
                onClick={onClose}
                className="w-full py-3 bg-white dark:bg-slate-800 text-gray-400 dark:text-gray-500 hover:bg-gray-50 dark:hover:bg-slate-700 rounded-2xl font-bold transition-colors"
              >
                {t('seduction.cancelBtn')}
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}